import css from "styled-jsx/css";

export default css`
  .my-consents-fake {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    &--container {
      display: flex;
      flex-direction: column;
      gap: 1rem;
      width: 100%;
    }
    &--title {
      height: 1rem;
      width: 20%;
    }
    &--box {
      border-radius: 8px;
      border: 1px solid #DDDDDD;
      padding: 1rem;
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }
    &--name {
      height: 18px;
      width: 70%;
    }
    &--descr {
      height: 60px;
      width: 100%;
    }
  }

  @media screen and (min-width: 1024px) {
    .my-consents-fake--container {
      width: 60%;
    }
  }
`;
